export let SAVE_EQUIPMENT = 'save_equipment';
export let CANCEL_ADD_EQUIPMENT = 'cancel_add_equipment';
export const EQUIPMENT_NAME = 'equipment_name';
export const SERIAL_NUMBER = 'serial_number';
